import { render, staticRenderFns } from "./YourSchool.vue?vue&type=template&id=316c9d96"
import script from "./YourSchool.vue?vue&type=script&lang=js"
export * from "./YourSchool.vue?vue&type=script&lang=js"
import style0 from "./YourSchool.vue?vue&type=style&index=0&id=316c9d96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Card: require('/app/nuxt/components/Card.vue').default,Section: require('/app/nuxt/components/Section.vue').default})
